// extracted by mini-css-extract-plugin
export default {"formContainer":"Posts_formContainer__kpw47","showMore":"Posts_showMore__Tp7ND","gap":"Posts_gap__gEVSR","marginEmptyPage":"Posts_marginEmptyPage__OnzS4"};